import React, { FC, ReactNode } from "react";
import { SvgIcon } from "../../SvgIcon/SvgIcon";
import classNames from "classnames";
import { Icons } from "../../SvgIcon/types";
import { CardIconSizeVariant } from "./CardIconSizeVariant";

export interface CardProps {
  heading: string;
  description?: ReactNode;
  label?: string;
  iconName?: Icons;
  iconSize?: CardIconSizeVariant;
  className?: string;
  useInitialStepStyle?: boolean;
  imageUrl?: string;
  showArrow?: boolean;
}

export const Card: FC<CardProps> = (props) => {
  const {
    heading,
    description,
    label,
    iconName,
    iconSize = "large",
    className,
    useInitialStepStyle,
    imageUrl,
    showArrow = false,
  } = props;

  return (
    // TODO: New suffix added to avoid conflicts with existing legacy Bootstrap component styles. Remove the suffix after the Bootstrap is removed.
    <div
      className={classNames(
        "CardNew",
        !!useInitialStepStyle && "CardNew__initialStepStyle",
        className
      )}
    >
      <div className="CardNew__topContent">
        {iconName && (
          <SvgIcon
            iconName={iconName}
            className={classNames(
              "CardNew__icon",
              iconSize === "large" && "CardNew__icon--large",
              iconSize === "medium" && "CardNew__icon--medium"
            )}
          />
        )}
        {imageUrl && (
          <img src={imageUrl} alt={heading} className="CardNew__image" />
        )}
        <div className="CardNew__info-container">
          <h4 className="CardNew__heading">{heading}</h4>
          {label && <span className="CardNew__label">{label}</span>}
        </div>
        {showArrow && (
          <div className="CardNew__icon-wrapper">
            <SvgIcon
              iconName={"chevron-right-thin"}
              className="CardNew__chevronIcon"
            />
          </div>
        )}
      </div>
      {description && <p className="CardNew__description">{description}</p>}
    </div>
  );
};
